import React, { ReactNode } from 'react';
import { Alert, Box } from '@mui/material';

type PageShellProps = {
  header?: ReactNode;
  error?: string | null;
  onErrorDismiss?: () => void;
  children: ReactNode;
};

const PageShell: React.FC<PageShellProps> = ({
  header,
  error,
  onErrorDismiss,
  children,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      minWidth: 0,
      width: '100%',
      flex: 1,
      minHeight: 0,
    }}
  >
    {header ? <Box sx={{ flexShrink: 0 }}>{header}</Box> : null}

    {error ? (
      <Alert severity="error" onClose={onErrorDismiss} sx={{ flexShrink: 0 }}>
        {error}
      </Alert>
    ) : null}

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default PageShell;
